import type {
  Character,
  CharacterWithPosition,
} from '~/app/_types/chat-script';
import type { PartialProtoCharacter, PartialProtoImage } from './types';

export const convertCharacter = (
  character: PartialProtoCharacter,
  imageResources: PartialProtoImage[]
): Character | undefined => {
  const image = imageResources.find(
    (image) => image.id === character?.image_id
  );
  if (!character || !character.id || !image) return;
  return {
    id: character.id,
    name: character.name ?? '',
    thumbnailUrl: image.serving_url ?? '',
  };
};

export const convertCharacterWithPosition = (
  character: Character,
  mainCharacterIdList: string[]
): CharacterWithPosition => {
  return {
    ...character,
    position: mainCharacterIdList.includes(character.id) ? 'right' : 'left',
  };
};
